(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted-experts"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.scroll-trigger').forEach((el) => observer.observe(el));

  document.querySelectorAll('.trusted-experts-carousel-section').forEach((section) => {
    const track = section.querySelector('.trusted-experts-carousel-track');
    const viewport = section.querySelector('.trusted-experts-carousel-viewport');
    const prevButton = section.querySelector('.trusted-experts-carousel__nav--prev');
    const nextButton = section.querySelector('.trusted-experts-carousel__nav--next');
    const cards = section.querySelectorAll('.trusted-experts-card');

    let currentIndex = 0;
    
    function update() {
      if (window.innerWidth <= 768) {
        track.style.transform = 'none';
        return;
      }
      const gap = 20;
      const cardWidth = (cards[0]?.offsetWidth || 0) + gap;
      const totalWidth = track.scrollWidth;
      const viewportWidth = viewport.offsetWidth;
      const maxScroll = Math.max(0, totalWidth - viewportWidth);
      
      let transformValue = currentIndex * cardWidth;
      if (transformValue > maxScroll) {
        transformValue = maxScroll;
      }
      
      track.style.transform = `translate3d(-${transformValue}px,0,0)`;
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const gap = 20;
        const cardWidth = (cards[0]?.offsetWidth || 0) + gap;
        const totalWidth = track.scrollWidth;
        const viewportWidth = viewport.offsetWidth;
        const maxScroll = Math.max(0, totalWidth - viewportWidth);

        if (currentIndex * cardWidth < maxScroll) { 
          currentIndex++; 
          update(); 
        }
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        if (currentIndex > 0) { 
          currentIndex--; 
          update(); 
        }
      });
    }

    window.addEventListener('resize', update);
    setTimeout(update, 200);
  });

  // Video Play Logic with object-position: top center
  const allCards = document.querySelectorAll('.trusted-experts-card');
  allCards.forEach((card) => {
    const trigger = card.querySelector('.trusted-video-trigger');
    const wrapper = card.querySelector('.trusted-experts-card__video-wrapper');
    if (!trigger || !wrapper) return;

    trigger.addEventListener('click', function(e) {
      if (e.target.closest('.product-info')) return;

      const videoUrl = trigger.dataset.videoUrl;
      if (!videoUrl) return;

      allCards.forEach((otherCard) => {
        if (otherCard !== card) {
          otherCard.classList.remove('video-playing');
          const otherWrapper = otherCard.querySelector('.trusted-experts-card__video-wrapper');
          if (otherWrapper) otherWrapper.innerHTML = '';
        }
      });

      if (card.classList.contains('video-playing')) {
         card.classList.remove('video-playing');
         wrapper.innerHTML = '';
         return;
      }

      card.classList.add('video-playing');
      if (videoUrl.includes('.mp4') || videoUrl.includes('.webm')) {
        wrapper.innerHTML = `<video src="${videoUrl}" autoplay controls playsinline style="width:100%;height:100%;object-fit:cover;object-position:top center;"></video>`;
      } else {
        let embedUrl = videoUrl;
        if (videoUrl.includes('youtube.com/watch?v=')) embedUrl = videoUrl.replace('watch?v=', 'embed/');
        wrapper.innerHTML = `<iframe src="${embedUrl}?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen style="width:100%;height:100%;border:0;"></iframe>`;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
